/* eslint-disable react/prop-types */
import { Grid, MenuItem, Select } from '@mui/material';
import SoftBox from 'components/SoftBox';
import React from 'react'
import renderInputField from 'utils/renderInputField';
import SoftTypography from 'components/SoftTypography';
import SoftButton from 'components/SoftButton';

export default function Fields({ method, information, setInformation, handleUpdate, submit }) {
    const handleChange = (event) => {
        const { name, value } = event.target;
        setInformation({ ...information, [name]: value });
    };

    const handleImageChange = (event) => {
        const { name, files } = event.target;
        setInformation({ ...information, [name]: files });
    };
    return (
        <SoftBox py={3}>
            <SoftBox component="form" role="form">
                <Grid container spacing={3}>
                    {renderInputField("name", "نام", "text", "نام", information, handleChange)}
                    {[{
                        label: "دسترسی", name: "access_level",
                        options: [
                            { value: 1, label: 'ALL' },
                            { value: 2, label: 'CHILD' },
                            { value: 3, label: 'INVESTOR' },
                        ]
                    }].map((selectField, index) => (
                        <Grid item xs={12} sm={6} xl={3} key={index}>
                            <SoftBox mb={1} ml={0.5}>
                                <SoftTypography component="label" variant="caption" fontWeight="bold">
                                    {selectField.label}
                                </SoftTypography>
                            </SoftBox>
                            <Select name={selectField.name} value={String(information[selectField.name])} onChange={handleChange} fullWidth>
                                {selectField.options.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid>
                    ))}
                    <Grid item xs={12} sm={6} xl={3}>
                        <SoftBox mb={1} ml={0.5}>
                            <SoftTypography component="label" variant="caption" fontWeight="bold">
                                آیکون
                            </SoftTypography>
                        </SoftBox>
                        <input
                            name="icon"
                            onChange={handleImageChange}
                            type="file"
                            style={{
                                background: 'white',
                                padding: '8px 12px',
                                width: '100%',
                                border: '0.0625rem solid #d2d6da',
                                borderRadius: '0.5rem',
                                color: '#495057'
                            }}
                            placeholder="Images"
                            accept=".jpg,.jpeg,.png"
                        />
                    </Grid>
                </Grid>
                <SoftButton
                    onClick={method !== "update" ? submit : handleUpdate}
                    style={{ marginTop: 40 }}
                    variant="gradient"
                    color="info"
                >
                    {method !== "update" ? "ثبت" : "آپدیت"}
                </SoftButton>
            </SoftBox>
        </SoftBox>
    )
}
